import React, { useState } from "react";
import styled from "styled-components";
import FormGroup from "../parts/FormGroup";
import TextField from "../parts/TextField";
import { useNavigate } from "react-router";
import ButtonSubmit from "../parts/ButtonSubmit";

const HeaderSearchFormStyle = styled(FormGroup)`
  border-radius: 3px;
  padding: 20px 30px;
  margin: 0;

  @media (max-width: 768px) {
    padding: 10px 15px;
  }
`;

const FieldsStyle = styled.div`
  display: flex;
  column-gap: 10px;
  justify-content: space-between;

  @media (max-width: 768px) {
    column-gap: 10px;
  }
`;

const SearchButtonStyle = styled(ButtonSubmit)`
  flex-shrink: 0;
`;

const ShopSearch: React.FC = () => {
  const [area, setArea] = useState<string>();
  const [shopName, setShopName] = useState<string>();
  const navigate = useNavigate();

  const handleSubmit = (event) => {
    event.preventDefault();
    const params = {};
    if (area) params["area"] = area;
    if (shopName) params["shopName"] = shopName;
    const urlSearchParam = new URLSearchParams(params).toString();
    navigate("/shops?" + urlSearchParam);
  };

  return (
    <HeaderSearchFormStyle onSubmit={handleSubmit}>
      <FieldsStyle>
        <TextField
          placeholder="エリア・駅"
          onChange={(event) => setArea(event.target.value)}
        />
        <TextField
          placeholder="店名"
          onChange={(event) => setShopName(event.target.value)}
        />
        <SearchButtonStyle value="検索" />
      </FieldsStyle>
    </HeaderSearchFormStyle>
  );
};

export default ShopSearch;
